import { skills } from "@/mocks/homeData";

export default function AboutSection() {
  return (
    <section id="about" className="py-20 md:py-28 lg:py-32 bg-stem-cream">
      <div className="section-padding max-w-6xl mx-auto">
        <span className="label text-revelBlue mb-4 block">
          Hi! Nice to meet you.
        </span>
        <h2 className="heading-lg text-stem-dark mb-6">
          I&rsquo;m Ahmad Danial. Welcome to a place where I share things I
          make.
        </h2>
        <p className="body-lg text-stem-gray mb-6">
          This website is where I post some of the things I enjoy making, like
          games, drawings, coding and tech projects, random ideas, and
          experiments.
        </p>
        <p className="body-lg text-stem-gray mb-6">
          I&rsquo;m interested in gaming, storytelling, technology, and creative
          problem solving. Recently, I&rsquo;ve also become more interested in
          language, discussion, and learning about real-world issues.
        </p>
        <p className="body-lg text-stem-gray mb-12">
          Most of the projects here are personal hobbies or ideas I explored for
          fun. I enjoy trying new things, improving my skills, and sharing my
          progress along the way.
        </p>

        {/* Skills Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {skills.map((skill) => (
            <div
              key={skill.name}
              className="bg-white rounded-xl p-5 md:p-6 border border-stem-sand hover:border-revelBlue/30 transition-colors group cursor-default"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-stem-cream group-hover:bg-revelBlue/10 transition-colors">
                  <i className={`${skill.icon} text-xl text-revelBlue`} />
                </div>
                <h3 className="font-semibold text-stem-dark">{skill.name}</h3>
              </div>
              <p className="text-sm text-stem-gray leading-relaxed">
                {skill.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
